const createRequestActionTypes = base => ({
  STARTED: `${base}_STARTED`,
  SUCCEEDED: `${base}_SUCCEEDED`,
  FAILED: `${base}_FAILED`
});
export const APP_STARTED = 'APP_STARTED';
export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const UPDATE_PATH_PARAMS = 'UPDATE_PATH_PARAMS';
export const REQUEST_EDITOR_TOUR = 'REQUEST_EDITOR_TOUR';
export const FETCH_ANALYZE_DATA_STARTED = 'FETCH_ANALYZE_DATA_STARTED';
export const FETCH_ANALYZE_DATA_SUCCEEDED = 'FETCH_ANALYZE_DATA_SUCCEEDED';
export const FETCH_ANALYZE_DATA_FAILED = 'FETCH_ANALYZE_DATA_FAILED';
export const FETCH_ANALYZE_POINTS_STARTED = 'FETCH_ANALYZE_POINTS_STARTED';
export const FETCH_ANALYZE_POINTS_SUCCEEDED = 'FETCH_ANALYZE_POINTS_SUCCEEDED';
export const FETCH_ANALYZE_POINTS_FAILED = 'FETCH_ANALYZE_POINTS_FAILED';
export const CLONE_INTERACTIVE_STARTED = 'CLONE_INTERACTIVE_STARTED';
export const CLONE_INTERACTIVE_FAILED = 'CLONE_INTERACTIVE_FAILED';
export const CLONE_INTERACTIVE_SUCCEEDED = 'CLONE_INTERACTIVE_SUCCEEDED';
export const DELETE_INTERACTIVE_STARTED = 'DELETE_INTERACTIVE_STARTED';
export const DELETE_INTERACTIVE_FAILED = 'DELETE_INTERACTIVE_FAILED';
export const DELETE_INTERACTIVE_SUCCEEDED = 'DELETE_INTERACTIVE_SUCCEEDED';
export const CREATE_INTERACTIVE_STARTED = 'CREATE_INTERACTIVE_STARTED';
export const CREATE_INTERACTIVE_FAILED = 'CREATE_INTERACTIVE_FAILED';
export const CREATE_INTERACTIVE_SUCCEEDED = 'CREATE_INTERACTIVE_SUCCEEDED';
export const ARCHIVE_INTERACTIVE_SUCCEEDED = 'ARCHIVE_INTERACTIVE_SUCCEEDED';
export const ARCHIVE_INTERACTIVE_FAILED = 'ARCHIVE_INTERACTIVE_FAILED';
export const UNPUBLISH_INTERACTIVE_STARTED = 'UNPUBLISH_INTERACTIVE_STARTED';
export const UNPUBLISH_INTERACTIVE_FAILED = 'UNPUBLISH_INTERACTIVE_FAILED';
export const UNPUBLISH_INTERACTIVE_SUCCEEDED = 'UNPUBLISH_INTERACTIVE_SUCCEEDED';
export const FETCH_USERS_SUCCEEDED = 'FETCH_USERS_SUCCEEDED';
export const FETCH_SHORT_DETAILS_SUCCEEDED = 'FETCH_SHORT_DETAILS_SUCCEEDED';
export const FETCH_DETAILS = createRequestActionTypes('FETCH_DETAILS');
export const UPDATE_NAME = 'UPDATE_NAME';
export const UPDATE_SEARCH_QUERY = 'UPDATE_SEARCH_QUERY';
export const UPDATE_FILTER_STATE = 'UPDATE_FILTER_STATE';
export const UPDATE_FILTER_CAMPAIGN = 'UPDATE_FILTER_CAMPAIGN';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const UPDATE_DATE_RANGE = 'UPDATE_DATE_RANGE';
export const UPDATE_FREQUENCY = 'UPDATE_FREQUENCY';
export const UPDATE_VIEW = 'UPDATE_VIEW';
export const CLEAR_PARAMS = 'CLEAR_PARAMS';
export const UPDATE_FILTER_CONTAINER_TYPE = 'UPDATE_FILTER_CONTAINER_TYPE';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const OPEN_MODAL = 'OPEN_MODAL';

// templates
export const FETCH_TEMPLATES_STARTED = 'FETCH_TEMPLATES_STARTED';
export const FETCH_TEMPLATES_SUCCEEDED = 'FETCH_TEMPLATES_SUCCEEDED';
export const FETCH_TEMPLATES_FAILED = 'FETCH_TEMPLATES_FAILED';
export const FETCH_PREVIEW_PAGES = createRequestActionTypes('FETCH_PREVIEW_PAGES');
export const FETCH_PREVIEW_DOMAIN_SUCCEEDED = 'FETCH_PREVIEW_DOMAIN_SUCCEEDED';

// embedding instructions
export const FETCH_EMBED_CODE_STARTED = 'FETCH_EMBED_CODE_STARTED';
export const FETCH_EMBED_CODE_SUCCEEDED = 'FETCH_EMBED_CODE_SUCCEEDED';
export const FETCH_EMBED_CODE_FAILED = 'FETCH_EMBED_CODE_FAILED';

// A/B testing
export const RUN_AB_TEST_STARTED = 'RUN_AB_TEST_STARTED';
export const RUN_AB_TEST_SUCCEEDED = 'RUN_AB_TEST_SUCCEEDED';
export const RUN_AB_TEST_FAILED = 'RUN_AB_TEST_FAILED';
export const GENERATE_AI_CTA_STARTED = 'GENERATE_AI_CTA_STARTED';
export const GENERATE_AI_CTA_SUCCEEDED = 'GENERATE_AI_CTA_SUCCEEDED';
export const GENERATE_AI_CTA_FAILED = 'GENERATE_AI_CTA_FAILED';
export const PICK_AB_TEST_WINNER_STARTED = 'PICK_AB_TEST_WINNER_STARTED';
export const PICK_AB_TEST_WINNER_SUCCEEDED = 'PICK_AB_TEST_WINNER_SUCCEEDED';
export const PICK_AB_TEST_WINNER_FAILED = 'PICK_AB_TEST_WINNER_FAILED';